<template>
  <div>
    <h3 class="my-3 mx-2">Create New Service Request</h3>
    <b-card>
      <b-row>
        <b-col>
          <h4>
            Customer Name:
            {{
              customerData && customerData.name ? customerData.name.first : ""
            }}
            {{
              customerData && customerData.name ? customerData.name.last : ""
            }}
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <eb-select
            :label="'orderId'"
            placeholder="*Select Order Number"
            v-model="orderNumber"
            :options="getOrderData"
          >
          </eb-select>
        </b-col>
        <b-col>
          <eb-select
            :label="'name'"
            placeholder="*Issue Details"
            v-model="category"
            :options="categoryList"
          >
          </eb-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <eb-select
            v-model="severity"
            :options="severityOptions"
            :label="'text'"
            placeholder="Select Severity"
            class="mb-0"
          >
          </eb-select>
        </b-col>
        <b-col>
          <c-input
            :inputId="`subject`"
            inputType="text"
            lableText="*Subject"
            v-model="subject"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <c-input
            :inputId="`description`"
            inputType="text"
            lableText="*Description"
            v-model="description"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <div class="form-group font-weight-bolder upload_file-Custome">
            <div class="file-upload-sec">
              <i class="fas fa-paperclip"> </i>
            </div>
            <b-form-file
              placeholder="Upload file"
              drop-placeholder="Drop file here..."
              @change="readLogo"
              :state="Boolean(attachments)"
            ></b-form-file>

            <p class="mb-0 mt-1">Attach file(jpeg,pdf,etc)</p>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col cols="4">
          <b-button
            variant="outline-primary"
            class="w-50 ml-5"
            @click="description = subject = ''"
            >CANCEL</b-button
          >
        </b-col>
        <b-col cols="4">
          <b-button variant="primary" class="w-50 ml-n5" @click="createTicket()"
            >SUBMIT
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import cInput from "@/components/Common/CustomInput";
import Vue from "vue";
export default {
  components: {
    ebSelect,
    cInput,
  },
  data() {
    return {
      attachments: "",
      subject: "",
      description: "",
      category: "",
      serviceReqId: "",
      currentUser: "",
      orderNumber: "",
      customerData: "",
      severity: "",
      severityOptions: [
        { text: "Low", value: "Low" },
        { text: "Medium", value: "Medium" },
        { text: "High", value: "High" },
        { text: "Critical", value: "Critical" },
      ],
    };
  },
  computed: {
    getOrderData() {
      return this.$store.getters["customerManagement/GetOrderList"];
    },
    categoryList() {
      let data = this.$store.getters["servicerequest/GetServiceRequestList"];
      let list = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            name: obj.name,
            _id: obj._id,
          };
          list.push(arrayObj);
        });
        return list;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    // upload images to the S3 bucket
    readLogo(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadImage(reader.result);
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.attachments = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    async createTicket() {
      let payload = {
        category: this.category._id,
        description: this.description,
        subject: this.subject,
        severity: this.severity.value,
        order: { orderId: this.orderNumber.orderId },
        attachments: [
          {
            url: this.attachments,
          },
        ],
        assignTo: {
          id: this.currentAgent,
          name: "hyderabadtsk",
          email: "htsk@gmail.com",
          userType: "SUB_DEALER",
          phone: "+91 80012 502030",
        },
        reportedTo: {
          id: this.currentAgent,
          name: "hyderabadtsk",
          email: "htsk@gmail.com",
          userType: "SUB_DEALER",
          phone: "+91 80012 502030",
        },
        reportedBy: {
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          userType: "TENANT",
          phone: this.$currentUserData.phone,
        },
      };
      try {
        await this.$store
          .dispatch("customerManagement/createServiceTicket", payload)
          .then((payload) => {
            this.$swal({
              title: "Success",
              text: "Service Ticket Created successfully!!",
              type: "success",
            });
          });
        this.$router.push({
          name: "Customer-Management-Listing",
          params: {
            id: this.currentAgent,
            userData: this.currentAgent,
          },
        });
      } catch (err) {
        this.$swal({
          title: "Opps!!!!!",
          text: "Please Enter correct Information!!!!",
          type: "error",
        });
      }
    },
    async fetchOrderData() {
      const payload = {
        id: this.currentAgent,
        limit: "20",
        type: "PRODUCT",
        orderId: "",
        status: "",
        toDate: "",
        fromDate: "",
      };
      await this.$store.dispatch("customerManagement/getOrderList", payload);
    },
    async fetchCategoryList() {
      await this.$store.dispatch("servicerequest/fetchServicerequestList");
    },
  },
  mounted() {
    this.customerData = this.$route.params.customerData;
    this.currentAgent = this.$route.params.id;
    this.fetchCategoryList();
    this.fetchOrderData();
  },
};
</script>

<style>
.upload_file-Custome {
  display: flex;
}

.upload_file-Custome p {
  display: inline-block;
  line-height: 3;
  cursor: pointer;
}

.file-upload-sec {
  height: 50px;
  width: 50px;
  border-radius: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid #ffffff;
  overflow: hidden;
  background-image: linear-gradient(to bottom, #415eb6 50%, #ffffff 50%);
  background-size: 100% 200%;
  transition: all 1s;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
}

.custom-file {
  position: absolute;
  width: 250px;
  top: 13px;
  height: 47px;
  opacity: 0;
  cursor: pointer;
}

.custom-file-input {
  height: 47px !important;
  cursor: pointer !important;
}

.attachIcon {
  border-radius: 30px;
  height: 45px;
  width: 45px;
  background-color: #2d6c44;
  color: #fff;
}
</style>